<template>
  <nav class="navbar navbar-expand-lg fixed-top glass-navbar" :class="{ 'scrolled': isScrolled, 'navbar-hidden': !isVisible }">
    <div class="container-fluid px-4">


      <div class="navbar-wrapper d-flex align-items-center justify-content-between w-100">
        <router-link to="/" class="navbar-brand d-flex align-items-center gap-2" @click="closeMobileMenu">
          <div class="brand-icon">
            <i class="bi bi-building-fill"></i>
          </div>
          <div class="brand-text-container">
            <span class="brand-text">PORTEO</span>
            <span class="brand-subtitle">ERP BTP</span>
          </div>
        </router-link>

        <div class="navbar-actions d-flex align-items-center gap-2 gap-md-4">
          <div class="collapse navbar-collapse d-none d-lg-block" id="navbarNav">
            <ul v-if="isAuthenticated" class="navbar-nav mx-auto align-items-center gap-1">
              <!-- Dashboard -->
              <li v-if="!isPointeur && !isSupervisor" class="nav-item">
                <router-link to="/" class="nav-link">
                  <i class="bi bi-grid-1x2-fill me-1"></i> 
                  <span>Dashboard</span>
                </router-link>
              </li>
              
              <!-- Gestion Projet -->
              <li v-if="hasProjetAccess" class="nav-item dropdown custom-dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false">
                  <i class="bi bi-stack me-1"></i>
                  <span>Gestion Projet</span>
                </a>
                <div class="dropdown-menu glass-dropdown-menu animate-slideUp">
                  <router-link v-if="!isHR && !isPointeur && !isSupervisor" to="/projects" class="dropdown-item">
                    <i class="bi bi-briefcase-fill me-3 text-primary"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Projets</span>
                      <span class="item-desc">Liste et suivi des chantiers</span>
                    </div>
                  </router-link>
                  <router-link v-if="!isHR && !isPointeur && !isSupervisor" to="/planning" class="dropdown-item">
                    <i class="bi bi-calendar-week-fill me-3 text-info"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Planning</span>
                      <span class="item-desc">Calendrier et échéances</span>
                    </div>
                  </router-link>
                  <router-link v-if="isAdmin" to="/budget" class="dropdown-item">
                    <i class="bi bi-cash-stack me-3 text-success"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Budget</span>
                      <span class="item-desc">Gestion financière globale</span>
                    </div>
                  </router-link>
                  <router-link v-if="canViewBudgetControl" to="/budget-control" class="dropdown-item">
                    <i class="bi bi-speedometer2 me-3 text-warning"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Contrôle Budgétaire</span>
                      <span class="item-desc">Analyse des coûts</span>
                    </div>
                  </router-link>
                  <router-link v-if="isQhseUser || isAdmin" to="/qhse" class="dropdown-item">
                    <i class="bi bi-shield-check me-3 text-success"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">QHSE</span>
                      <span class="item-desc">Qualité, Hygiène, Sécurité, Environnement</span>
                    </div>
                  </router-link>
                </div>
              </li>

              <!-- Ressources -->
              <li v-if="hasRessourcesAccess" class="nav-item dropdown custom-dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false">
                  <i class="bi bi-people-fill me-1"></i>
                  <span>Ressources</span>
                </a>
                <div class="dropdown-menu glass-dropdown-menu animate-slideUp">
                  <router-link v-if="canViewResources && !isPointeur && !isSupervisor" to="/resources" class="dropdown-item">
                    <i class="bi bi-diagram-3-fill me-3 text-indigo"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Ressources</span>
                      <span class="item-desc">Annuaire des ressources</span>
                    </div>
                  </router-link>
                  <router-link v-if="canViewPersonnel && !isPointeur && !isSupervisor" to="/personnel" class="dropdown-item">
                    <i class="bi bi-person-badge-fill me-3 text-primary"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Personnel</span>
                      <span class="item-desc">Gestion des employés</span>
                    </div>
                  </router-link>
                  <router-link v-if="!isHR && !isPointeur && !isSupervisor" to="/materiel" class="dropdown-item">
                    <i class="bi bi-gear-fill me-3 text-secondary"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Matériel</span>
                      <span class="item-desc">Parc engins et équipements</span>
                    </div>
                  </router-link>
                </div>
              </li>

              <!-- Chantier -->
              <li v-if="hasChantierAccess" class="nav-item dropdown custom-dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" aria-expanded="false">
                  <i class="bi bi-clipboard2-pulse-fill me-1"></i>
                  <span>Chantier</span>
                </a>
                <div class="dropdown-menu glass-dropdown-menu animate-slideUp">
                  <router-link v-if="canViewExpenseReports" to="/daily-expense-reports" class="dropdown-item">
                    <i class="bi bi-receipt-cutoff me-3 text-danger"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Dépenses</span>
                      <span class="item-desc">Rapports de frais journaliers</span>
                    </div>
                  </router-link>
                  <router-link v-if="canViewSiteReports" to="/site-reports" class="dropdown-item">
                    <i class="bi bi-clipboard2-data-fill me-3 text-info"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Rapport Chantier</span>
                      <span class="item-desc">Saisie des rapports quotidiens</span>
                    </div>
                  </router-link>
                  <router-link v-if="canCreateSiteReports" to="/photos-chantier" class="dropdown-item">
                    <i class="bi bi-camera-fill me-3" style="color: #7c3aed;"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Photos Chantier</span>
                      <span class="item-desc">Ajouter des photos par activité</span>
                    </div>
                  </router-link>
                  <router-link v-if="canValidateSiteReports" to="/site-reports/validation" class="dropdown-item">
                    <i class="bi bi-clipboard-check-fill me-3 text-success"></i> 
                    <div class="d-flex flex-column">
                      <span class="item-title">Validation</span>
                      <span class="item-desc">Contrôle et approbation</span>
                    </div>
                  </router-link>
                </div>
              </li>

              <!-- Team -->
              <li v-if="isDirector" class="nav-item">
                <router-link to="/team-management" class="nav-link">
                  <i class="bi bi-people-fill me-1"></i> 
                  <span>Équipe</span>
                </router-link>
              </li>

              <!-- Admin -->
              <li v-if="isAdmin" class="nav-item">
                <router-link to="/admin" class="nav-link">
                  <i class="bi bi-shield-lock-fill me-1"></i> 
                  <span>Admin</span>
                </router-link>
              </li>
            </ul>
          </div>
          
          <ul class="navbar-nav ms-auto align-items-center gap-2 gap-md-3 flex-row">
            <li v-if="isAuthenticated" class="nav-item">
              <NotificationCenter />
            </li>
            
            <li v-if="isAuthenticated" class="nav-item dropdown">
              <a class="nav-link user-profile-link d-flex align-items-center gap-2" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <div class="avatar-circle shadow-sm">
                  {{ userInitials }}
                </div>
                <div class="d-none d-xl-flex flex-column text-start">
                  <span class="user-name">{{ user.name }}</span>
                  <span class="user-role">{{ userRole }}</span>
                </div>
                <i class="bi bi-chevron-down ms-1 small opacity-50 d-none d-md-block"></i>
              </a>
              <ul class="dropdown-menu dropdown-menu-end shadow-lg border-0 user-dropdown" aria-labelledby="userDropdown">
                <li class="px-3 py-2">
                  <div class="text-xs fw-bold text-uppercase text-muted tracking-wide mb-1">Compte</div>
                  <div class="fw-medium text-dark truncate-email">{{ user.email }}</div>
                </li>
                <li><hr class="dropdown-divider my-1"></li>
                <li>
                  <button class="dropdown-item d-flex align-items-center gap-2" @click="goToProfile">
                    <i class="bi bi-person-gear"></i> 
                    <span>Mon Profil</span>
                  </button>
                </li>
                <li>
                  <button class="dropdown-item d-flex align-items-center gap-2" @click="goToSettings">
                    <i class="bi bi-sliders"></i> 
                    <span>Paramètres</span>
                  </button>
                </li>
                <li><hr class="dropdown-divider my-1"></li>
                <li>
                  <button class="dropdown-item d-flex align-items-center gap-2 text-danger" @click="logout">
                    <i class="bi bi-box-arrow-right"></i> 
                    <span>Déconnexion</span>
                  </button>
                </li>
              </ul>
            </li>
            <li v-else class="nav-item">
              <router-link to="/login" class="btn btn-primary btn-sm px-3 px-md-4 rounded-pill shadow-lg hover-lift">
                <span class="fw-semibold">Connexion</span>
              </router-link>
            </li>

            <!-- Hamburger (Mobile Only) -->
            <li class="nav-item d-lg-none">
              <button class="mobile-toggle-btn" type="button" @click="toggleMobileMenu">
                <div class="hamburger-icon" :class="{ 'active': isMobileMenuOpen }">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </nav>

  <Teleport to="body">
    <div class="mobile-overlay" :class="{ 'active': isMobileMenuOpen }" @click="closeMobileMenu"></div>
    
    <div class="mobile-drawer" :class="{ 'open': isMobileMenuOpen }">
      <div class="drawer-header">
        <div class="d-flex align-items-center gap-2">
          <div class="brand-icon sm">
            <i class="bi bi-building-fill"></i>
          </div>
          <span class="brand-text">PORTEO</span>
        </div>
        <button class="btn-close-drawer" @click="closeMobileMenu">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="drawer-body">
        <div v-if="isAuthenticated" class="user-drawer-info mb-4">
          <div class="d-flex align-items-center gap-3">
            <div class="avatar-circle lg">
              {{ userInitials }}
            </div>
            <div class="d-flex flex-column">
              <span class="user-name fw-bold">{{ user.name }}</span>
              <span class="user-role fs-xs">{{ userRole }}</span>
            </div>
          </div>
        </div>

        <div class="drawer-nav">
          <ul v-if="isAuthenticated" class="navbar-nav gap-2">
            <li v-if="!isPointeur && !isSupervisor" class="nav-item">
              <router-link to="/" class="mobile-nav-link" @click="closeMobileMenu">
                <i class="bi bi-grid-1x2-fill"></i> 
                <span>Tableau de bord</span>
              </router-link>
            </li>

            <!-- Mobile Sections -->
            <div class="nav-section-label">Gestion Projet</div>
            <router-link v-if="!isHR && !isPointeur && !isSupervisor" to="/projects" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-briefcase-fill text-primary"></i> 
              <span>Projets</span>
            </router-link>
            <router-link v-if="!isHR && !isPointeur && !isSupervisor" to="/planning" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-calendar-week-fill text-info"></i> 
              <span>Planning</span>
            </router-link>
            <router-link v-if="isAdmin" to="/budget" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-cash-stack text-success"></i> 
              <span>Budget</span>
            </router-link>
            <router-link v-if="canViewBudgetControl" to="/budget-control" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-speedometer2 text-warning"></i> 
              <span>Contrôle Budgétaire</span>
            </router-link>
            <router-link v-if="isQhseUser || isAdmin" to="/qhse" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-shield-check text-success"></i> 
              <span>QHSE</span>
            </router-link>

            <div class="nav-section-label">Ressources</div>
            <router-link v-if="canViewResources && !isPointeur && !isSupervisor" to="/resources" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-diagram-3-fill text-indigo"></i> 
              <span>Ressources</span>
            </router-link>
            <router-link v-if="canViewPersonnel && !isPointeur && !isSupervisor" to="/personnel" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-person-badge-fill text-primary"></i> 
              <span>Personnel</span>
            </router-link>
            <router-link v-if="!isHR && !isPointeur && !isSupervisor" to="/materiel" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-gear-fill text-secondary"></i> 
              <span>Matériel</span>
            </router-link>

            <div class="nav-section-label">Chantier</div>
            <router-link v-if="canViewExpenseReports" to="/daily-expense-reports" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-receipt-cutoff text-danger"></i> 
              <span>Dépenses</span>
            </router-link>
            <router-link v-if="canViewSiteReports" to="/site-reports" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-clipboard2-data-fill text-info"></i> 
              <span>Rapport Chantier</span>
            </router-link>
            <router-link v-if="canCreateSiteReports" to="/photos-chantier" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-camera-fill" style="color: #7c3aed;"></i> 
              <span>Photos Chantier</span>
            </router-link>
            <router-link v-if="canValidateSiteReports" to="/site-reports/validation" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-clipboard-check-fill text-success"></i> 
              <span>Validation</span>
            </router-link>

            <div v-if="isDirector" class="nav-section-label">Équipe</div>
            <router-link v-if="isDirector" to="/team-management" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-people-fill text-primary"></i> 
              <span>Équipe</span>
            </router-link>

            <div v-if="isAdmin" class="nav-section-label">Administration</div>
            <router-link v-if="isAdmin" to="/admin" class="mobile-nav-link" @click="closeMobileMenu">
              <i class="bi bi-shield-lock-fill text-dark"></i> 
              <span>Admin</span>
            </router-link>
          </ul>
        </div>
      </div>
      
      <div class="drawer-footer">
        <button v-if="isAuthenticated" class="btn btn-light w-100 text-danger border-0 d-flex align-items-center justify-content-center gap-2" @click="logout">
          <i class="bi bi-box-arrow-right"></i>
          <span>Déconnexion</span>
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '../composables/useAuth'
import NotificationCenter from './NotificationCenter.vue'

export default {
  name: 'Navbar',
  components: {
    NotificationCenter
  },
  setup() {
    const router = useRouter()
    const { 
      isAuthenticated, 
      user, 
      logout: authLogout,
      isAdmin,
      isDirector,
      isCostController,
      isHR,
      isPointeur,
      isSupervisor,
      isQhsePays,
      isQhseChantier,
      isRelaisQhse,
      isQhseUser,
      hasPermission
    } = useAuth()

    const isScrolled = ref(false)
    const isVisible = ref(true)
    const lastScrollY = ref(0)
    const scrollThreshold = 100 // Minimal scroll before hiding
    const isMobileMenuOpen = ref(false)

    const handleScroll = () => {
      const currentScrollY = window.scrollY
      
      // Update scrolled state (floating effect)
      isScrolled.value = currentScrollY > 20

      // Navigation visibility logic
      if (currentScrollY < scrollThreshold) {
        isVisible.value = true
      } else if (currentScrollY > lastScrollY.value) {
        // Scrolling down
        isVisible.value = false
      } else {
        // Scrolling up
        isVisible.value = true
      }

      lastScrollY.value = currentScrollY
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value
    }

    const closeMobileMenu = () => {
      isMobileMenuOpen.value = false
    }

    const hasProjetAccess = computed(() => {
      return isAdmin.value || isQhsePays.value || (!isHR.value && !isPointeur.value && !isSupervisor.value && !isQhseChantier.value && !isRelaisQhse.value) || hasPermission('projects.view')
    })

    const hasRessourcesAccess = computed(() => {
      return canViewResources.value || canViewPersonnel.value || (!isHR.value && !isPointeur.value && !isSupervisor.value)
    })

    const hasChantierAccess = computed(() => {
      return (
        isAdmin.value || 
        isPointeur.value || 
        isSupervisor.value || 
        canViewSiteReports.value || 
        canValidateSiteReports.value || 
        canViewExpenseReports.value
      )
    })

    const canViewExpenseReports = computed(() => {
      return hasPermission('daily_reports.view')
    })

    const canViewResources = computed(() => {
      return hasPermission('resources.view')
    })

    const canViewPersonnel = computed(() => {
      return hasPermission('personnel.view')
    })

    const canViewSiteReports = computed(() => {
      return hasPermission('site_reports.view')
    })

    const canValidateSiteReports = computed(() => {
      return hasPermission('site_reports.validate')
    })

    const canCreateSiteReports = computed(() => {
      return hasPermission('site_reports.create')
    })

    const canViewBudgetControl = computed(() => {
      return isAdmin.value || hasPermission('budget_control.view')
    })

    const userInitials = computed(() => {
      if (!user.value || !user.value.name) return 'U'
      return user.value.name
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .substring(0, 2)
    })

    const userRole = computed(() => {
      if (isAdmin.value) return 'Administrateur'
      if (isDirector.value) return 'Directeur'
      if (isHR.value) return 'RH'
      if (isQhsePays.value) return 'Resp. QHSE Pays'
      if (isQhseChantier.value) return 'Resp. QHSE Chantier'
      if (isRelaisQhse.value) return 'Relais QHSE'
      return 'Utilisateur'
    })

    const goToProfile = () => {
      closeMobileMenu()
      router.push('/profile')
    }

    const goToSettings = () => {
      closeMobileMenu()
      router.push('/settings')
    }

    const logout = async () => {
      closeMobileMenu()
      await authLogout()
      router.push('/login')
    }

    return {
      isAuthenticated,
      user,
      isAdmin,
      isDirector,
      isCostController,
      isHR,
      isPointeur,
      isSupervisor,
      isQhsePays,
      isQhseChantier,
      isRelaisQhse,
      isQhseUser,
      canViewResources,
      canViewPersonnel,
      canViewSiteReports,
      canValidateSiteReports,
      canCreateSiteReports,
      canViewExpenseReports,
      canViewBudgetControl,
      hasProjetAccess,
      hasRessourcesAccess,
      hasChantierAccess,
      userInitials,
      userRole,
      isScrolled,
      isVisible,
      isMobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
      goToProfile,
      goToSettings,
      logout
    }
  }
}
</script>

<style scoped>
/* 
  ------------------------------------------------------------------
  CORE VARIABLES & MIXINS
  ------------------------------------------------------------------
*/
:root {
  --navbar-height-expanded: 80px;
  --navbar-height-scrolled: 64px;
  --glass-border: 1px solid rgba(255, 255, 255, 0.4);
  --glass-bg: rgba(255, 255, 255, 0.65);
  --glass-shadow: 0 8px 32px rgba(31, 38, 135, 0.07);
  --primary-gradient: linear-gradient(135deg, #4f46e5 0%, #3730a3 100%);
  --hover-bg: rgba(79, 70, 229, 0.08);
}

/* 
  ------------------------------------------------------------------
  NAVBAR CONTAINER - "FLOATING ISLAND" CONCEPT
  ------------------------------------------------------------------
*/
.glass-navbar {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1rem 0;
  transition: padding 0.4s ease, background 0.4s ease, border-radius 0.4s ease, width 0.4s ease, top 0.4s ease, box-shadow 0.4s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1050;
  width: 100%;
  will-change: padding, width, top, transform, border-radius, opacity;
  backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
}

.glass-navbar.scrolled {
  background: rgba(255, 255, 255, 0.85);
  padding: 0.6rem 0;
  top: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 1280px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 20px 40px -4px rgba(0, 0, 0, 0.1), 
    0 12px 16px -4px rgba(0, 0, 0, 0.05),
    inset 0 0 0 1px rgba(255, 255, 255, 0.4);
}

/* 
  ------------------------------------------------------------------
  SCROLL VISIBILITY (Modern Hide/Show)
  ------------------------------------------------------------------
*/
.navbar-hidden {
  transform: translateY(-110%);
  opacity: 0;
  pointer-events: none;
}

.glass-navbar.scrolled.navbar-hidden {
  transform: translateX(-50%) translateY(-150%) scale(0.95);
  opacity: 0;
}

/* Optimize for ultra-wide screens */
@media (min-width: 1600px) {
  .glass-navbar.scrolled {
    max-width: 1400px;
  }
}

/* Disable floating effect on mobile for better UX */
@media (max-width: 991px) {
  .glass-navbar.scrolled {
    width: 100%;
    top: 0;
    left: 0;
    transform: none;
    border-radius: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
}

/* 
  ------------------------------------------------------------------
  BRANDING
  ------------------------------------------------------------------
*/
.brand-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #4f46e5 0%, #3730a3 100%);
  color: white;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  box-shadow: 0 10px 20px -5px rgba(79, 70, 229, 0.4);
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  overflow: hidden;
}

.brand-icon::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0.3), transparent);
  opacity: 0.5;
}

.brand-icon.sm {
  width: 36px;
  height: 36px;
  font-size: 1.1rem;
  border-radius: 10px;
}

.navbar-brand:hover .brand-icon {
  transform: rotate(-8deg) scale(1.1);
}

.brand-text {
  font-family: 'Outfit', sans-serif;
  font-weight: 800;
  font-size: 1.35rem;
  line-height: 1;
  background: linear-gradient(135deg, #020617 0%, #1e293b 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.8px;
}

.brand-subtitle {
  font-size: 0.7rem;
  font-weight: 700;
  color: #4f46e5;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-top: 2px;
  display: block;
}

/* 
  ------------------------------------------------------------------
  NAVIGATION LINKS
  ------------------------------------------------------------------
*/
.nav-link {
  font-weight: 600;
  color: #1e293b !important;
  transition: all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1);
  padding: 0.6rem 1rem !important;
  border-radius: 14px;
  margin: 0 0.2rem;
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  position: relative;
  border: 1px solid transparent;
}

.nav-link:hover {
  color: #312e81 !important;
  background: rgba(255, 255, 255, 0.8);
  border-color: rgba(79, 70, 229, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.nav-link.router-link-active {
  color: #fff !important;
  background: linear-gradient(135deg, #4f46e5 0%, #3730a3 100%);
  box-shadow: 0 8px 16px -4px rgba(79, 70, 229, 0.4);
}

/* 
  ------------------------------------------------------------------
  PREMIUM DROPDOWNS
  ------------------------------------------------------------------
*/
.custom-dropdown .dropdown-toggle::after {
  display: none;
}

.glass-dropdown-menu {
  position: absolute !important;
  top: calc(100% + 15px);
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 24px 48px -12px rgba(0, 0, 0, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  border-radius: 20px;
  padding: 1rem;
  min-width: 320px;
  z-index: 1100;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;
}

.nav-item.dropdown.custom-dropdown:hover .glass-dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

/* Bootstrap click-based dropdown support (for user menu) */
.glass-dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

/* Grid Layout for Dropdowns */
.glass-dropdown-menu {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;
}

@media (min-width: 992px) {
  /* Make wider dropdowns for certain items if they have many sub-items */
  .nav-item:nth-child(2) .glass-dropdown-menu, /* Gestion Projet */
  .nav-item:nth-child(3) .glass-dropdown-menu, /* Ressources */
  .nav-item:nth-child(4) .glass-dropdown-menu /* Chantier */
  {
      min-width: 500px;
      grid-template-columns: repeat(2, 1fr);
  }
}

.dropdown-item {
  display: flex !important;
  align-items: flex-start;
  padding: 0.85rem 1rem !important;
  border-radius: 14px !important;
  transition: all 0.2s ease !important;
  background: transparent !important;
  border: 1px solid transparent;
}

.dropdown-item:hover {
  background: rgba(248, 250, 252, 0.8) !important;
  border-color: rgba(226, 232, 240, 0.8);
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.dropdown-item i {
  font-size: 1.25rem;
  margin-top: 0.1rem;
  transition: transform 0.3s ease;
}

.dropdown-item:hover i {
  transform: scale(1.2) rotate(5deg);
}

.item-title {
  font-weight: 700;
  font-size: 0.95rem;
  color: #1e293b;
  margin-bottom: 0.15rem;
  display: block;
}

.item-desc {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  line-height: 1.3;
}

/* 
  ------------------------------------------------------------------
  USER PROFILE & ACTIONS
  ------------------------------------------------------------------
*/
.user-profile-link {
  padding: 0.4rem 0.6rem !important;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 50px;
  transition: all 0.3s ease;
}

.user-profile-link:hover {
  background: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.avatar-circle {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  color: #4338ca;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.user-name {
  font-weight: 700;
  font-size: 0.85rem;
  color: #1e293b;
}

.user-role {
  font-size: 0.65rem;
  font-weight: 700;
  color: #4f46e5;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: rgba(79, 70, 229, 0.08); /* subtle badge bg */
  padding: 1px 6px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 2px;
}

/* User Dropdown Menu - Click based */
.user-dropdown {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  padding: 0.5rem;
  min-width: 220px;
  margin-top: 0.5rem;
}

@media (max-width: 991px) {
  .user-dropdown {
    position: absolute !important;
    right: 0 !important;
    left: auto !important;
    transform: none !important;
    margin-top: 1rem !important;
    z-index: 1060;
  }
}

/* 
  ------------------------------------------------------------------
  MOBILE DRAWER
  ------------------------------------------------------------------
*/
.mobile-toggle-btn {
  background: transparent;
  border: none;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e293b;
}

.hamburger-icon span {
  width: 24px;
  height: 2.5px;
  background-color: currentColor;
  border-radius: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: block;
  margin: 5px 0;
}

.hamburger-icon.active span:nth-child(1) { transform: translateY(7.5px) rotate(45deg); }
.hamburger-icon.active span:nth-child(2) { opacity: 0; transform: translateX(10px); }
.hamburger-icon.active span:nth-child(3) { transform: translateY(-7.5px) rotate(-45deg); }

/* Mobile Drawer & Overlay */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(4px);
  z-index: 1040;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mobile-drawer {
  position: fixed;
  top: 0;
  right: -100%;
  width: 85%;
  max-width: 320px;
  height: 100vh;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  z-index: 1060;
  box-shadow: -10px 0 40px rgba(0, 0, 0, 0.1);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
}

.mobile-drawer.open {
  right: 0;
}

.drawer-header {
  padding: 1.25rem;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-close-drawer {
  background: #f8fafc;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem 1rem;
}

.drawer-footer {
  padding: 1rem;
  border-top: 1px solid #f1f5f9;
  background: #f8fafc;
}

.nav-section-label {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #94a3b8;
  letter-spacing: 0.05em;
  margin: 1.25rem 0 0.5rem 0.75rem;
}

/* 
  ------------------------------------------------------------------
  ANIMATIONS
  ------------------------------------------------------------------
*/
@keyframes slideUpFade {
  from { opacity: 0; transform: translateY(15px) translateX(-50%); }
  to { opacity: 1; transform: translateY(0) translateX(-50%); }
}

.animate-slideUp {
  animation: slideUpFade 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0.75rem 0.75rem;
  border-radius: 12px;
  color: #1e293b;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

.mobile-nav-link:hover {
  background: rgba(248, 250, 252, 0.8);
  color: #4f46e5;
}

.mobile-nav-link i {
  font-size: 1.1rem;
  width: 24px;
  text-align: center;
  transition: transform 0.2s;
}

.mobile-nav-link:hover i {
  transform: scale(1.1);
}

.mobile-nav-link:active, .mobile-nav-link.router-link-active {
  background: rgba(79, 70, 229, 0.08);
  color: #4f46e5;
}

.fs-xs { font-size: 0.75rem; }

/* Responsive adjustments */
@media (max-width: 991.98px) {
  .container-fluid { padding-inline: 1rem !important; }
}
</style>
